// extracted by mini-css-extract-plugin
export default {"products":"tB-z","card":"uB-z","oosMessaging":"vB-z"};